const imagesThumbs = new Swiper("#product_thumbs", {
    slidesPerView: 5,
    slidesPerGroup: 1,
    spaceBetween: 10,
    freeMode: true,
    direction: "vertical",
    watchSlidesProgress: true,
    breakpoints: {
        1: {
            direction: "horizontal",
            slidesPerView: 3,
        },
        540: {
            direction: "vertical",
            slidesPerView: 5,
        },
    },
});

const imagesMain = new Swiper("#product_main", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    pauseOnMouseEnter: true,
    loop: true,
    observer: true,
    zoom: {
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
    },
    navigation: {
        nextEl: "#product_main .next",
        prevEl: "#product_main .prev",
    },
    thumbs: {
        swiper: imagesThumbs,
    },
});
